"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CloseBar;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CloseBar = _interopRequireDefault(require("../style/CloseBar.scss"));

var _ChevronUp = _interopRequireDefault(require("@react/react-spectrum/Icon/ChevronUp"));

var _Close = _interopRequireDefault(require("@react/react-spectrum/Icon/Close"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button/js/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * CloseBar component
 * @param {object} props - properties of component
 * @returns {ReactElement} markup
 */
function CloseBar(_ref) {
  var onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      onBarClick = _ref.onBarClick,
      showCloseButton = _ref.showCloseButton;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_CloseBar.default.component, " close-bar")
  }, showCloseButton ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    label: null,
    onClick: onClick,
    onMouseDown: onMouseDown,
    variant: "tool",
    icon: /*#__PURE__*/_react.default.createElement(_Close.default, {
      size: "S"
    })
  }) : /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "chevron-button",
    label: null,
    onClick: onBarClick,
    variant: "tool",
    icon: /*#__PURE__*/_react.default.createElement(_ChevronUp.default, {
      size: "M"
    })
  }));
}

CloseBar.defaultProps = {
  onClick: undefined,
  onMouseDown: undefined,
  onBarClick: undefined,
  showCloseButton: true
};
CloseBar.propTypes = {
  onClick: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onBarClick: _propTypes.default.func,
  showCloseButton: _propTypes.default.bool
};